import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { GatewayChannelWithChargePointInfoModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-channel-with-charge-point-info.model';
import { formatDate } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/formatters/format-date';
import { CellContext } from '@tanstack/react-table';

import i18n from '@app/core/locale/i18n';

export interface ChannelListLastMessageReceivedDateCellProps
  extends CellContext<
    GatewayChannelWithChargePointInfoModel,
    GatewayChannelWithChargePointInfoModel['lastMessageReceivedDate']
  > {}

export const ChannelListLastMessageReceivedDateCell = (
  props: ChannelListLastMessageReceivedDateCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  const value = getValue();

  return <Text truncate>{value ? formatDate(value, i18n) : '-'}</Text>;
};
